/* BipBip — tema davranışları. Harici kütüphane kullanılmaz. */
(function () {
  'use strict';

  var routes = (window.BipBip && window.BipBip.routes) || {};
  var strings = (window.BipBip && window.BipBip.strings) || {};

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function fetchJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function claim(element, key) {
    if (!element || element.dataset[key] === 'true') return false;
    element.dataset[key] = 'true';
    return true;
  }

  function sectionHTML(sections, id, selector) {
    if (!sections || !sections[id]) return null;
    var doc = new DOMParser().parseFromString(sections[id], 'text/html');
    return doc.querySelector(selector);
  }

  /* ------------------------------------------------------------------
     Header
     ------------------------------------------------------------------ */

  function initHeader() {
    var header = $('[data-header]');
    if (!header || !claim(header, 'bpBound')) return;

    var menu = $('[data-mobile-menu]', header);
    var toggles = $$('[data-menu-toggle]', header);

    function setMenu(open) {
      if (!menu) return;
      menu.toggleAttribute('hidden', !open);
      header.classList.toggle('header--menu-open', open);
      document.body.classList.toggle('overflow-hidden', open);
      toggles.forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    toggles.forEach(function (button) {
      button.addEventListener('click', function () {
        setMenu(menu.hasAttribute('hidden'));
      });
    });

    if (menu) {
      $$('a', menu).forEach(function (link) {
        link.addEventListener('click', function () {
          setMenu(false);
        });
      });
    }

    $$('[data-cart-open]', header).forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (!drawer.element) return;
        event.preventDefault();
        drawer.open();
      });
    });

    var searchToggle = $('[data-search-toggle]', header);
    var search = $('[data-search-panel]', header);
    if (searchToggle && search) {
      searchToggle.addEventListener('click', function () {
        var open = search.hasAttribute('hidden');
        search.toggleAttribute('hidden', !open);
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = $('input[type="search"]', search);
          if (input) input.focus();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setMenu(false);
      if (search && !search.hasAttribute('hidden')) {
        search.setAttribute('hidden', '');
        if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      }
    });

    var lastScroll = 0;
    var ticking = false;

    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('header--scrolled', y > 8);
      lastScroll = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(onScroll);
      },
      { passive: true }
    );

    onScroll();
  }

  /* ------------------------------------------------------------------
     Sepet sayacı
     ------------------------------------------------------------------ */

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.toggleAttribute('hidden', count === 0);
    });
  }

  /* ------------------------------------------------------------------
     Sepet paneli (drawer)
     ------------------------------------------------------------------ */

  var drawer = {
    element: null,
    lastFocus: null,

    init: function () {
      this.element = $('[data-cart-drawer]');
      this.bindItems();

      if (!this.element || !claim(this.element, 'bpBound')) return;

      var self = this;

      this.element.addEventListener('click', function (event) {
        if (event.target.hasAttribute('data-cart-close') || event.target.closest('[data-cart-close]')) {
          self.close();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && self.isOpen()) self.close();
      });

    },

    isOpen: function () {
      return this.element && this.element.classList.contains('cart-drawer--open');
    },

    open: function () {
      if (!this.element) return;
      this.lastFocus = document.activeElement;
      this.element.classList.add('cart-drawer--open');
      this.element.removeAttribute('inert');
      document.body.classList.add('overflow-hidden');
      var closeButton = $('[data-cart-close]', this.element);
      if (closeButton) closeButton.focus();
    },

    close: function () {
      if (!this.element) return;
      this.element.classList.remove('cart-drawer--open');
      document.body.classList.remove('overflow-hidden');
      if (this.lastFocus) this.lastFocus.focus();
    },

    refresh: function (sections) {
      if (!this.element) return;
      var fresh = sectionHTML(sections, 'cart-drawer', '[data-cart-drawer-inner]');
      var inner = $('[data-cart-drawer-inner]', this.element);
      if (fresh && inner) {
        inner.innerHTML = fresh.innerHTML;
        this.bindItems();
      }
    },

    bindItems: function () {
      if (!this.element) return;
      bindCartControls(this.element);
    }
  };

  /* ------------------------------------------------------------------
     Sepet satır kontrolleri (drawer + sepet sayfası ortak)
     ------------------------------------------------------------------ */

  function setCartBusy(scope, busy) {
    scope.classList.toggle('is-busy', busy);
  }

  function changeCartLine(scope, line, quantity) {
    setCartBusy(scope, true);

    return fetchJSON(routes.cart_change_url, {
      line: line,
      quantity: quantity,
      sections: 'cart-drawer,main-cart',
      sections_url: window.location.pathname
    })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        drawer.refresh(cart.sections);
        refreshCartPage(cart.sections);
        document.dispatchEvent(new CustomEvent('bipbip:cart:updated', { detail: cart }));
      })
      .catch(function () {
        window.location.href = routes.cart_url;
      })
      .finally(function () {
        setCartBusy(scope, false);
      });
  }

  function bindCartControls(scope) {
    if (!scope) return;

    $$('[data-cart-line-change]', scope).forEach(function (button) {
      if (!claim(button, 'bpBound')) return;
      button.addEventListener('click', function () {
        var line = button.getAttribute('data-line');
        var quantity = parseInt(button.getAttribute('data-quantity'), 10);
        changeCartLine(scope, line, Math.max(0, quantity));
      });
    });

    $$('[data-cart-line-input]', scope).forEach(function (input) {
      if (!claim(input, 'bpBound')) return;
      input.addEventListener('change', function () {
        var line = input.getAttribute('data-line');
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        changeCartLine(scope, line, quantity);
      });
    });

    bindCartAttributes(scope);
  }

  function refreshCartPage(sections) {
    var page = $('[data-cart-page]');
    if (!page) return;
    var fresh = sectionHTML(sections, 'main-cart', '[data-cart-page-inner]');
    var inner = $('[data-cart-page-inner]', page);
    if (fresh && inner) {
      inner.innerHTML = fresh.innerHTML;
      bindCartControls(page);
    }
  }

  /* ------------------------------------------------------------------
     İşletme bilgisi (cart attributes)
     ------------------------------------------------------------------ */

  function bindCartAttributes(scope) {
    var form = $('[data-business-form]', scope);
    if (!form || !claim(form, 'bpBound')) return;

    var status = $('[data-business-status]', form);
    var timer = null;

    function save() {
      var attributes = {};
      $$('[data-attribute]', form).forEach(function (field) {
        attributes[field.getAttribute('data-attribute')] = field.value;
      });

      var note = $('[data-cart-note]', form);

      fetchJSON(routes.cart_update_url, {
        attributes: attributes,
        note: note ? note.value : undefined
      })
        .then(function () {
          if (!status) return;
          status.hidden = false;
          status.textContent = 'Bilgileriniz kaydedildi.';
          status.className = 'form-status form-status--success';
        })
        .catch(function () {
          if (!status) return;
          status.hidden = false;
          status.textContent = 'Bilgiler kaydedilemedi, lütfen tekrar deneyin.';
          status.className = 'form-status form-status--error';
        });
    }

    $$('[data-attribute], [data-cart-note]', form).forEach(function (field) {
      field.addEventListener('change', save);
      field.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(save, 900);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      save();
    });
  }

  /* ------------------------------------------------------------------
     Ürün formu
     ------------------------------------------------------------------ */

  function initProductForms() {
    $$('[data-product-form]').forEach(function (root) {
      if (!claim(root, 'bpBound')) return;

      var variantScript = $('[data-variant-data]', root);
      var variants = [];
      if (variantScript) {
        try {
          variants = JSON.parse(variantScript.textContent);
        } catch (error) {
          variants = [];
        }
      }

      var input = $('[data-variant-input]', root);
      var addButton = $('[data-add-button]', root);
      var addButtonText = $('[data-add-button-text]', root);
      var errorNode = $('[data-form-error]', root);
      var form = $('form', root);

      function findVariant(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      $$('[data-variant-option]', root).forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;

          $$('.package', root).forEach(function (label) {
            label.classList.remove('package--selected');
          });
          var parentLabel = radio.closest('.package');
          if (parentLabel) parentLabel.classList.add('package--selected');

          if (input) input.value = radio.value;

          var variant = findVariant(radio.value);
          if (variant && addButton) {
            addButton.disabled = !variant.available;
            if (addButtonText) {
              addButtonText.textContent = variant.available ? 'Sepete Ekle' : strings.soldOut || 'Tükendi';
            }
          }
        });
      });

      $$('[data-qty-change]', root).forEach(function (button) {
        button.addEventListener('click', function () {
          var field = $('.qty__input', root);
          if (!field) return;
          var step = parseInt(button.getAttribute('data-qty-change'), 10);
          field.value = Math.max(1, (parseInt(field.value, 10) || 1) + step);
        });
      });

      if (!form) return;

      form.addEventListener('submit', function (event) {
        if (!routes.cart_add_url) return;
        event.preventDefault();

        if (errorNode) errorNode.hidden = true;
        if (addButton) {
          addButton.setAttribute('aria-busy', 'true');
          addButton.disabled = true;
        }

        var formData = new FormData(form);
        var payload = {
          items: [
            {
              id: formData.get('id'),
              quantity: parseInt(formData.get('quantity'), 10) || 1
            }
          ],
          sections: 'cart-drawer'
        };

        fetchJSON(routes.cart_add_url, payload)
          .then(function (response) {
            return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                updateCartCount(cart.item_count);
                drawer.refresh(response.sections);
                if (window.BipBip.cartType === 'drawer' && drawer.element) {
                  drawer.open();
                } else {
                  window.location.href = routes.cart_url;
                }
              });
          })
          .catch(function (error) {
            if (errorNode) {
              errorNode.hidden = false;
              errorNode.textContent =
                (error && error.description) || strings.addToCartError || 'Ürün sepete eklenemedi.';
            }
          })
          .finally(function () {
            if (addButton) {
              addButton.removeAttribute('aria-busy');
              addButton.disabled = false;
            }
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     Yorumlar carousel
     ------------------------------------------------------------------ */

  function initCarousels() {
    $$('[data-carousel]').forEach(function (carousel) {
      var track = $('[data-carousel-track]', carousel);
      if (!track || !claim(carousel, 'bpBound')) return;

      var prev = $('[data-carousel-prev]', carousel);
      var next = $('[data-carousel-next]', carousel);

      function step(direction) {
        var card = track.firstElementChild;
        var distance = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      function syncButtons() {
        var max = track.scrollWidth - track.clientWidth - 4;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncButtons);
      }, { passive: true });

      window.addEventListener('resize', syncButtons);
      syncButtons();
    });
  }

  /* ------------------------------------------------------------------
     Başlat
     ------------------------------------------------------------------ */

  function init() {
    initHeader();
    drawer.init();
    initProductForms();
    initCarousels();
    bindCartControls(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
